import React from "react";
import ReactSelect from "react-select";
import { SELECT_STYLES, SELECT_THEME } from "../Pages/admin/shared/tokens";

/*
 * PCSelect — react-select with the unified admin field SKIN baked in.
 *
 * Drop-in replacement: screens keep importing `Select` and using <Select .../>.
 * The skin (bordered white, 4px radius, crimson focus, Inter) is the single
 * canonical react-select style from shared/tokens.js, so every dropdown matches
 * the text inputs next to it and the SELECT_STYLES used on transaction pages.
 *
 * Per-instance props still win: a screen passing its own `styles={{...}}`
 * overrides the matching style key here; a `theme` prop replaces the theme.
 */

export const pcSelectStyles = SELECT_STYLES;

export const pcSelectTheme = SELECT_THEME;

export default function PCSelect({ styles, theme, ...props }) {
    return (
        <ReactSelect
            styles={{ ...pcSelectStyles, ...(styles || {}) }}
            theme={theme || pcSelectTheme}
            {...props}
        />
    );
}
